import { h, Component } from "preact";
import AddToCalendar from "../../components/addToCalender/ReactAddToCalendar";
import EventsService from "../../services/EventsService";
import icCalender from "../../assets/images/ic_calender.svg";
import { css } from "emotion";

const btnWrapper = css({
  margin: "-40px 0 42px 0",
  "@media(max-width: 600px)": {
    margin: "-24px 0 24px 30px"
  }
});

const btnClass = css({
  fontSize: 14,
  fontWeight: 600,
  display: "block",
  minWidth: 200,
  color: "#196097"
});

const EventAddToCalender = ({ event, theme, eventDate }) => {
  if (!event) {
    return null;
  }
  if (!eventDate) {
    const validDates = event.data.dates.filter(date => date.valid);
    if (validDates.length === 1) {
      eventDate = validDates[0];
    } else {
      return null;
    }
  }
  if (!eventDate) {
    return null;
  }
  const hideCalendar = event.data.settings.hideAddToCalendar;
  if (hideCalendar) {
    return null;
  }

  const parts = [];
  if (event.data.location.venueName) {
    parts.push(event.data.location.venueName);
  }
  if (event.data.location.address) {
    parts.push(event.data.location.address.replace(",", ""));
  }

  const eventCalender = {
    title: event.data.name,
    description: EventsService.getCalendarDescription(event.data),
    location: parts.join(" "),
    startTime: eventDate.startDate,
    endTime: eventDate.endDate
  };

  return (
    <div className={btnWrapper}>
      <AddToCalendar event={eventCalender}>
        <a className={btnClass}>Add to calendar</a>
      </AddToCalendar>
    </div>
  );
};

export default EventAddToCalender;



// WEBPACK FOOTER //
// ./routes/event/EventAddToCalender.js